const isProduction = process.env.NODE_ENV === "production";

const imageExists = function (url: string, callback: (exists: boolean) => void) {
	var img = new Image();
	img.onload = function () {
		callback(true);
	};
	img.onerror = function () {
		callback(false);
	};
	img.src = url;
};

export function checkIfImageExists(
	{ url, interval = 2000, timeout = 10000 }: { url: string; interval?: number; timeout?: number },
	cb: (exists: boolean | null) => void,
) {
	let start = new Date(),
		fileExists = false;

	if (!isProduction) {
		cb(true);
		return;
	}

	imageExists(url, function (exists) {
		if (exists) {
			cb(true);
			return;
		}
		let int = setInterval(() => {
			imageExists(url, function (exists1) {
				fileExists = exists1;
				if (fileExists || new Date().getTime() - start.getTime() > timeout) {
					clearInterval(int);
					cb(fileExists || null);
				}
			});
		}, interval);
	});
}
